module.exports = __webpack_public_path__ + "3ac319a6a821a5cf6ac96803f0b6923f.vtt";